/* flow-strict */

import { GET, POST, PUT } from '/client/src/api';

const urls = {
  facebook_connect: '/api/v1/1/merchants/facebook/connect',
  facebook_current: '/api/v1/1/merchants/facebook/current',
  facebook_install: '/api/v1/1/merchants/facebookpages/install',
  facebook_uninstall: '/api/v1/1/merchants/facebookpages/uninstall',
  facebook_placement_index: '/api/v1/1/merchants/facebookpages/{0}/events/{1}'
};

export function facebookpagesInstall(fbUserId, pageId, pageName) {
  return POST(
    urls.facebook_install,
    {
      facebook_user_id: fbUserId,
      page_id: pageId,
      page_name: pageName
    }
  );
}

export function facebookpagesUninstall(fbUserId, pageId) {
  return POST(
    urls.facebook_uninstall,
    {
      facebook_user_id: fbUserId,
      page_id: pageId
    }
  );
}

/**
 * Link to facebook
 */
export function facebookConnect(data) {
  return POST(
    urls.facebook_connect,
    data
  );
}

export async function facebookCurrent() {
  const { result } = await GET(urls.facebook_current);

  return result;
}

export function updateFacebookpages(page_id, event_id, data) { // data: { is_display: boolean, placement_index: number }
  return PUT(
    `urls.facebook_placement_index&page_id=${page_id}&event_id=${event_id}`,
    data
  );
}
